<template>
  <div class="pt-3 px-4 case-loads-container">
    <div
      class="d-flex flex-row justify-content-between align-items-center mb-3"
    >
      <div class="d-flex flex-row justify-content-start align-items-center">
        <div
          class="main-image-container bg-purple rounded d-flex justify-content-center align-items-center"
        >
          <img
            height="25"
            width="25"
            :src="require('../../assets/icons/leader.svg')"
          />
        </div>
        <h3 class="mb-0 ml-3">Case Load</h3>
      </div>
      <b-button
        variant="primary"
        @click="assignUserToCase"
        class="smaller-button button-custom-blue"
        ><i class="fa fa-plus mr-2" aria-hidden="true"></i> Assign User to
        Case</b-button
      >
    </div>
    <div class="filters-container">
      <div
        class="d-flex flex-row justify-content-between align-items-center bg-light-gray min-width-fit-content"
      >
        <div class="d-flex flex-wrap align-items-center">
          <span class="ml-4 mr-3" style="font-size: 14px;"
            >Active filters:</span
          >
          <div
            class="filter-value bg-white border pr-2 pt-1 pb-1 m-1"
            v-for="(u, uIndex) in filterUser"
            :key="u.value"
          >
            <div class="d-flex justify-content-between align-items-center">
              <span class="mr-3"
                >User: <span class="color-filter">{{ u.label }}</span></span
              >
              <i
                class="fa fa-times text-danger hover-pointer hover-text-almost-black"
                @click="removeUserFilter(uIndex)"
              ></i>
            </div>
          </div>
          <div
            class="filter-value bg-white border pr-2 pt-1 pb-1 m-1"
            v-for="(c, cIndex) in filterClient"
            :key="c.value"
          >
            <div class="d-flex justify-content-between align-items-center">
              <span class="mr-3"
                >Patient: <span class="color-filter">{{ c.label }}</span></span
              >
              <i
                class="fa fa-times text-danger hover-pointer hover-text-almost-black"
                @click="removeClientFilter(cIndex)"
              ></i>
            </div>
          </div>
          <div
            class="filter-value bg-white border pr-2 pt-1 pb-1 m-1"
            v-for="(cR, cRIndex) in filterCaseRole"
            :key="cR.value"
          >
            <div class="d-flex justify-content-between align-items-center">
              <span class="mr-3"
                >Case Role:
                <span class="color-filter">{{ cR.label }}</span></span
              >
              <i
                class="fa fa-times text-danger hover-pointer hover-text-almost-black"
                @click="removeCaseRoleFilter(cRIndex)"
              ></i>
            </div>
          </div>
          <span
            v-if="hasFilters"
            class="clear-all-filters text-danger ml-2"
            style="font-size: 14px;"
            @click="clearAllFilters"
            >Clear all filters</span
          >
        </div>
        <div class="d-flex align-self-stretch align-items-center">
          <div class="align-self-stretch" style="padding: 9px 0px;">
            <div class="vertical-separator border-med-light-gray"></div>
          </div>
          <b-dropdown
            id="dropdown-form"
            text="Filters"
            ref="filterDropdown"
            class="container-main bg-light-gray"
            toggle-class="d-flex flex-row justify-content-between align-items-lg-center bg-transparent border-0 color-custom-dark-grey dropdown-menu-label"
            menu-class="container-filter-main-menu"
            toggle-tag="div"
            boundary="window"
            right
            @hide="onFilterHide"
          >
            <template #button-content>
              <div class="d-flex align-items-center mr-2">
                <i
                  class="fas fa-filter text-primary mr-2"
                  style="font-size: 15px;"
                  aria-hidden="true"
                ></i>
                <span style="font-size: 14px;">Filters</span>
              </div>
            </template>
            <b-dropdown-form class="px-2">
              <b-form-group label="Filter by:">
                <b-form-select
                  v-model="selectedFilter"
                  :options="filterOptions"
                />
              </b-form-group>
              <multiple-select-filter
                v-if="selectedFilter == 'user'"
                :label="'Users'"
                :options="users"
                v-model="filterUser"
                :width="filterWidth()"
                :showSearch="true"
                @on-search="updatePopper"
                @on-text-selection="updateTextSelection"
                :key="'user'"
                ref="userFilter"
              />
              <multiple-select-filter
                v-if="selectedFilter == 'patient'"
                :label="'Patients (Active & Pending only)'"
                :options="clientOptions"
                v-model="filterClient"
                :width="filterPatientWidth()"
                :showSearch="true"
                @on-search="searchEocs"
                @on-text-selection="updateTextSelection"
                :key="'patient'"
                ref="patientFilter"
              >
                <template v-slot:item-option="{ itemOption, selected }">
                  <eoc-filter-option-template
                    :eoc="itemOption.data"
                    :selected="selected"
                  />
                </template>
              </multiple-select-filter>
              <multiple-select-filter
                v-if="selectedFilter == 'caseRole'"
                :label="'Case Role'"
                :options="caseRoles"
                v-model="filterCaseRole"
                :width="filterWidth()"
                :showSearch="false"
                :key="'caseRole'"
              />
            </b-dropdown-form>
          </b-dropdown>
        </div>
      </div>
    </div>

    <div
      class="caseLoads-list caseLoad-data mt-2"
      ref="caseLoadsList"
      :style="`--filter-height:` + filterHeight()"
    >
      <zoom-area :hideControls="true">
        <div class="h-100">
          <div
            v-for="caseLoad in caseLoads"
            :key="caseLoad.user.id"
            class="d-flex flex-row mb-2"
          >
            <div
              class="d-flex flex-column justify-content-center align-items-center bg-light-gray border border-med-light-gray p-2"
            >
              <div
                class="caseLoad-avatar rounded-circle mb-2 picture-preview"
                style="width: 100px; height: 100px;"
              >
                <img
                  v-if="caseLoad.user && !caseLoad.user.avatarId"
                  :src="require(`../../assets/avatar-example.png`)"
                />
                <div
                  v-else-if="
                    caseLoad.user &&
                      caseLoad.user.avatarId &&
                      !userAvatars[caseLoad.user.avatarId]
                  "
                  class="w-100 h-100 d-flex justify-content-center align-items-center text-center"
                >
                  <span class="color-custom-dark-grey" style="font-size: 18px"
                    >Loading image</span
                  >
                </div>
                <img v-else :src="userAvatars[caseLoad.user.avatarId]" />
              </div>
              <span>{{ caseLoad.user | formatUser }}</span>
            </div>
            <div
              v-for="caseRole in caseLoad.caseRoles"
              :key="caseRole.caseRole.id"
              class="ml-4 position-relative caseRole"
            >
              <div
                class="caseRole-header d-flex flex-row justify-content-between align-items-center position-relative p-1 pl-2 pr-2"
                :style="
                  `--bg-header-color:${
                    getCaseRoleColor(caseRole.caseRole.id).bg
                  };--font-header-color:${
                    getCaseRoleColor(caseRole.caseRole.id).font
                  };`
                "
              >
                <span>{{ caseRole.caseRole.name }}</span>
                <span class="">({{ caseRole.patients.length }})</span>
                <span
                  class="add-case-load-sc font-weight-bold bg-white text-success rounded"
                  @click="addCaseLoadSC(caseLoad.user.id, caseRole.caseRole.id)"
                  >+</span
                >
              </div>
              <div
                class="d-flex justify-content-start align-items-start caseLoad-patient-container overflow-hidden"
                v-for="(chunk, chunkIndex) in chunks(caseRole.patients, 2)"
                :key="chunkIndex"
              >
                <div
                  class="d-flex flex-column bg-white justify-content-start align-items-center caseLoad-patient p-2"
                  v-for="{ patient, caseLoad: caseLoadObject } in chunk"
                  :key="patient.id"
                >
                  <div
                    class="caseLoad-patient-avatar rounded-circle picture-preview"
                  >
                    <img
                      v-if="patient && !patient.patient.avatarId"
                      :src="require(`../../assets/avatar-example.png`)"
                    />
                    <div
                      v-else-if="
                        patient &&
                          patient.patient.avatarId &&
                          !patientAvatars[patient.patient.avatarId]
                      "
                      class="w-100 h-100 d-flex justify-content-center align-items-center"
                    >
                      <span
                        class="color-custom-dark-grey text-center"
                        style="font-size: 8px"
                        >Loading image</span
                      >
                    </div>
                    <img
                      v-else
                      :src="patientAvatars[patient.patient.avatarId]"
                    />
                  </div>
                  <span class="">
                    {{ formatEocObj(patient) }}
                  </span>
                  <span
                    class="delete-case-load text-danger font-weight-bold"
                    @click="deleteCaseLoad(caseLoadObject.id)"
                    >X</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <b-button
          v-if="hasMore"
          @click="loadMore"
          variant="outline-secondary"
          class="mb-2"
          style="padding: 10px 30px !important; border-radius:0px;"
          >Load more users</b-button
        >
      </zoom-area>
    </div>

    <b-modal
      centered
      ref="form-modal"
      title="Assign User to Case"
      header-bg-variant="primary"
      header-text-variant="white"
      @ok="submitCaseLoad"
      no-close-on-backdrop
      header-class="bg-purple"
    >
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button variant="secondary" @click="cancel()">
          Cancel
        </b-button>
        <b-button variant="primary" @click="ok()">
          Save
        </b-button>
      </template>
      <b-form-group
        label="Case Role*"
        :state="formErrors.caseRoleId.length == 0 ? null : false"
        :invalid-feedback="formErrors.caseRoleId.join(', ')"
      >
        <v-select
          class=""
          placeholder=""
          v-model="caseRole"
          :options="caseRoles"
        ></v-select>
      </b-form-group>
      <b-form-group
        label="User*"
        :state="formErrors.userId.length == 0 ? null : false"
        :invalid-feedback="formErrors.userId.join(', ')"
      >
        <v-select
          class=""
          placeholder=""
          v-model="user"
          :options="
            caseRole && caseRole.data.type == 'PrimaryProvider'
              ? providerUsers
              : users
          "
        ></v-select>
      </b-form-group>
      <b-form-group
        label="Patient* (Active & Pending only)"
        :state="formErrors.episodeOfCare.length == 0 ? null : false"
        :invalid-feedback="formErrors.episodeOfCare.join(', ')"
      >
        <eoc-picker
          :eocs="clientOptions"
          v-model="client"
          :async="true"
          @search="
            ({ search, loading }) => fetchEocsOptionsPicker(search, loading)
          "
        />
      </b-form-group>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import caseLoadServer from "../../server/caseLoadRecord";
import userServer from "../../server/user";
import eocServer from "../../server/eoc";
import { chunks } from "../../helpers/general";
import { colors } from "../../config/layout";
import ZoomArea from "../controls/ZoomArea";
import { validateRequired } from "../../helpers/validation";
import avatarServer from "../../server/avatar";
import EocPicker from "../controls/EocPicker.vue";
import EocFilterOptionTemplate from "../../views/EocFilterOptionTemplate";

export default {
  name: "CaseLoadRecordsIndex",
  components: { ZoomArea, EocPicker, EocFilterOptionTemplate },
  props: ["showing"],
  data: () => ({
    list: [],
    hasMore: false,
    selectedFilter: "user",
    filterOptions: [
      {
        value: "user",
        text: "User"
      },
      {
        value: "patient",
        text: "Patient"
      },
      {
        value: "caseRole",
        text: "Case role"
      }
    ],
    filter: {
      page: 1,
      pageSize: 10,
      userIds: [],
      patientsIds: [],
      caseRoleIds: []
    },
    form: {
      userId: null,
      episodeOfCare: null,
      caseRoleId: null
    },
    formErrors: {
      userId: [],
      episodeOfCare: [],
      caseRoleId: []
    },
    users: [],
    clientOptions: [],
    patientAvatars: {},
    userAvatars: {},
    filterTextSelection: null,
    deletedCaseLoadId: null
  }),
  methods: {
    ...mapActions("layout", ["showAlertSuccess"]),
    ...mapActions("client", ["fetchCaseRoles"]),
    fetchInitialData() {
      this.list = [];
      this.fetchCaseRoles();
      this.searchCaseLoads(true);
      this.searchCaseLoads(false);
      this.getUsers();
      this.fetchClientOptions();
    },
    searchCaseLoads(delayed = true) {
      if (delayed) {
        if (this.lastTimeout) {
          clearTimeout(this.lastTimeout);
          this.lastTimeout = null;
        }
        this.lastTimeout = setTimeout(async () => {
          this.getCaseLoads();
        }, 1000);
      } else this.getCaseLoads();

      this.showResults = true;
    },
    loadMore() {
      this.filter.page += 1;
      this.searchCaseLoads(false);
    },
    async getCaseLoads() {
      var result = await caseLoadServer.query({
        ...this.filter,
        caseRoleIds: this.filter.caseRoleIds.map(cR => cR.value),
        userIds: this.filter.userIds.map(u => u.value),
        episodeOfCareIds: this.filter.patientsIds.map(p => p.value)
      });
      const allResults = [...this.list, ...result.records].reduce(
        (acc, item) => {
          if (
            !acc.some(x => x.id === item.id) &&
            this.deletedCaseLoadId != item.id
          ) {
            acc.push(item);
          }
          return acc;
        },
        []
      );
      this.list = allResults;
      this.hasMore = result.hasMore;
      this.downloadAvatars();
    },
    async downloadAvatars() {
      let patientAvatars = { ...this.patientAvatars };
      let userAvatars = { ...this.userAvatars };
      for (let index = 0; index < this.list.length; index++) {
        const caseLoad = this.list[index];
        if (
          caseLoad.episodeOfCare.patient.avatarId &&
          !patientAvatars[caseLoad.episodeOfCare.patient.avatarId]
        ) {
          try {
            patientAvatars[
              caseLoad.episodeOfCare.patient.avatarId
            ] = await avatarServer.downloadUrl(
              caseLoad.episodeOfCare.patient.avatarId
            );
          } catch {
            patientAvatars[
              caseLoad.episodeOfCare.patient.avatarId
            ] = require(`../../assets/avatar-example.png`);
          }
          this.patientAvatars = { ...patientAvatars };
        }
        if (caseLoad.user.avatarId && !userAvatars[caseLoad.user.avatarId]) {
          try {
            userAvatars[
              caseLoad.user.avatarId
            ] = await avatarServer.downloadUrl(caseLoad.user.avatarId);
          } catch {
            userAvatars[
              caseLoad.user.avatarId
            ] = require(`../../assets/avatar-example.png`);
          }
          this.userAvatars = { ...userAvatars };
        }
      }
    },
    async getUsers() {
      const users = await userServer.getMinimalUsers();
      this.users = users.map(user => ({
        value: user.id,
        label: this.formatUser(user),
        data: user
      }));
    },
    async fetchEocsOptionsPicker(search, loading) {
      if (this.lastTimeoutEocsOptionsPicker) {
        clearTimeout(this.lastTimeoutEocsOptionsPicker);
        this.lastTimeoutEocsOptionsPicker = null;
      }
      if (search && search.trim().length >= 3) {
        this.clientOptions = [];
      }
      this.lastTimeoutEocsOptionsPicker = setTimeout(async () => {
        if (!search || search.length == 0 || search.length >= 3) {
          if (search.length >= 3) {
            loading(true);
          }

          this.searchingEocs = true;
          const optionsResult = await eocServer.queryList(
            {
              searchPhrase: search,
              eocStatus:
                !search || search.length == 0 ? ["Active", "Pending"] : [],
              locations: this.locationId ? [this.locationId] : [],
              page: 1,
              pageSize: 50
            },
            {
              "Hide-Loading": true
            }
          );

          this.clientOptions = optionsResult.episodesOfCare.map(eoc => ({
            value: eoc.id,
            label: this.formatEocObj(eoc),
            data: eoc
          }));
          this.searchingEocs = false;
          if (search.length >= 3) {
            loading(false);
          }
        }
      }, 1000);
    },
    async fetchClientOptions() {
      const optionsResult = await eocServer.queryList(
        {
          searchPhrase: "",
          eocStatus: ["Active", "Pending"],
          locationId: [],
          page: 1,
          pageSize: 50
        },
        {
          "Hide-Loading": true
        }
      );
      this.clientOptions = optionsResult.episodesOfCare.map(eoc => ({
        value: eoc.id,
        label: this.formatEocObj(eoc),
        data: eoc
      }));
    },
    async searchEocs(search) {
      const s = search.trim();
      if (this.searchEocPhraseLength < 3 && s.length < 3) {
        return;
      }

      if (this.searchEocPhraseLength >= 3 && s.length < 3) {
        this.searchEocPhraseLength = s.length;
        await this.fetchEocs(search);
        return;
      }

      this.searchEocPhraseLength = s.length;

      if (this.lastTimeoutEocs) {
        clearTimeout(this.lastTimeoutEocs);
        this.lastTimeoutEocs = null;
      }

      this.clientOptions = [];

      this.lastTimeoutEocs = setTimeout(async () => {
        const response = await eocServer.queryList(
          {
            searchPhrase: search,
            eocStatus:
              !search || search.length == 0 ? ["Active", "Pending"] : [],
            page: 1,
            pageSize: 50
          },
          { "Hide-Loading": true }
        );
        this.clientOptions = response.episodesOfCare.map(eoc => ({
          value: eoc.id,
          label: this.formatEocObj(eoc),
          data: eoc
        }));
      }, 1000);
    },
    validateCaseLoadSubmit() {
      let withoutErrors = true;

      this.formErrors.userId = [];
      if (!validateRequired(this.form.userId)) {
        this.formErrors.userId.push("This field is required");
        withoutErrors = false;
      }

      this.formErrors.episodeOfCare = [];
      if (!validateRequired(this.form.episodeOfCare)) {
        this.formErrors.episodeOfCare.push("This field is required");
        withoutErrors = false;
      }

      this.formErrors.caseRoleId = [];
      if (!validateRequired(this.form.caseRoleId)) {
        this.formErrors.caseRoleId.push("This field is required");
        withoutErrors = false;
      }

      return withoutErrors;
    },
    async submitCaseLoad(modalEvent) {
      modalEvent.preventDefault();
      const result = await this.validateCaseLoadSubmit();
      if (result) {
        var caseLoad = await caseLoadServer.create({
          userId: this.form.userId,
          episodeOfCareId: this.form.episodeOfCare.value,
          caseRoleId: this.form.caseRoleId
        });
        if (!this.list.some(x => x.id === caseLoad.id))
          this.list.push(caseLoad);
        this.$refs["form-modal"].hide();
        this.showAlertSuccess();
        this.fetchInitialData();
      } else {
        //this.$dialog.alert("You have some errors in the form");
      }
    },
    assignUserToCase() {
      this.form = {
        userId: null,
        episodeOfCare: null,
        caseRoleId: null
      };
      this.$refs["form-modal"].show();
    },
    addCaseLoadSC(userId, caseRoleId) {
      this.form = {
        userId: userId,
        episodeOfCare: null,
        caseRoleId: caseRoleId
      };
      this.$refs["form-modal"].show();
    },
    deleteCaseLoad(caseLoadId) {
      this.$dialog
        .confirm(
          {
            title: "Are you sure you want to unassign this patient?"
          },
          {
            view: "confirm-delete"
          }
        )
        .then(async () => {
          this.deletedCaseLoadId = caseLoadId;
          try {
            await caseLoadServer.delete(caseLoadId);
            this.searchCaseLoads(false);
            this.showAlertSuccess();
          } catch {
            this.searchCaseLoads(false);
            this.showAlertSuccess();
          }
        })
        .catch(function() {});
    },
    chunks(patients, chunksCount) {
      return chunks(patients, chunksCount);
    },
    getCaseRoleColor(caseRoleId) {
      let caseRoleIndex = this.caseRoles
        .sort((caseRole1, caseRole2) =>
          caseRole1.label.localeCompare(caseRole2.label)
        )
        .map(caseRole => caseRole.value)
        .indexOf(caseRoleId);
      if (caseRoleIndex == -1) caseRoleIndex = 0;
      return colors[caseRoleIndex % colors.length];
    },
    removeCaseRoleFilter(index) {
      const newValue = [...this.filter.caseRoleIds];
      newValue.splice(index, 1);
      this.filterCaseRole = newValue;
    },
    removeUserFilter(index) {
      const newValue = [...this.filter.userIds];
      newValue.splice(index, 1);
      this.filterUser = newValue;
    },
    removeClientFilter(index) {
      const newValue = [...this.filter.patientsIds];
      newValue.splice(index, 1);
      this.filterClient = newValue;
    },
    clearAllFilters() {
      this.filterCaseRole = [];
      this.filterUser = [];
      this.filterClient = [];
    },
    filterHeight() {
      return (
        (this.$refs.filterHeight ? this.$refs.filterHeight.clientHeight : 0) +
        "px"
      );
    },
    filterWidth() {
      return "250px";
    },
    filterPatientWidth() {
      return "350px";
    },
    updatePopper() {
      this.$refs.filterDropdown.updatePopper();
    },
    onFilterHide(event) {
      let ref = null;
      if (this.selectedFilter == "user") {
        ref = this.$refs.userFilter;
      }
      if (this.selectedFilter == "patient") {
        ref = this.$refs.patientFilter;
      }
      if (this.filterTextSelection) {
        if (this.filterTextSelection) event.preventDefault();
        ref.highlightText();
        this.filterTextSelection = null;
      }
    },
    updateTextSelection(textSelection) {
      this.filterTextSelection = textSelection;
    },
    resetList() {
      this.filter.page = 1;
      this.list = [];
    }
  },
  computed: {
    ...mapState("client", {
      caseRoles: state =>
        state.caseRoles.map(caseRole => ({
          value: caseRole.id,
          label: caseRole.name,
          data: caseRole
        }))
    }),
    client: {
      get() {
        return this.form.episodeOfCare;
      },
      set(newValue) {
        this.form.episodeOfCare = newValue;
      }
    },
    filterClient: {
      get() {
        return this.filter.patientsIds;
      },
      set(newValues) {
        this.filter.patientsIds = newValues;
        this.resetList();
        this.searchCaseLoads();
      }
    },
    user: {
      get() {
        return this.form.userId
          ? this.users.find(user => user.value == this.form.userId)
          : null;
      },
      set(newValue) {
        this.form.userId = newValue ? newValue.value : null;
      }
    },
    filterUser: {
      get() {
        return this.filter.userIds;
      },
      set(newValues) {
        this.filter.userIds = newValues;
        this.resetList();
        this.searchCaseLoads();
      }
    },
    caseRole: {
      get() {
        return this.form.caseRoleId
          ? this.caseRoles.find(
              caseRole => caseRole.value == this.form.caseRoleId
            )
          : null;
      },
      set(newValue) {
        this.form.caseRoleId = newValue ? newValue.value : null;
        if (newValue && newValue.data.type == "PrimaryProvider")
          this.user = null;
      }
    },
    filterCaseRole: {
      get() {
        return this.filter.caseRoleIds;
      },
      set(newValue) {
        this.filter.caseRoleIds = newValue;
        this.resetList();
        this.searchCaseLoads();
      }
    },
    caseLoads() {
      const users = {};
      for (let index = 0; index < this.list.length; index++) {
        const caseLoad = this.list[index];
        if (!users[caseLoad.user.id]) {
          users[caseLoad.user.id] = {
            user: caseLoad.user,
            caseRoles: {}
          };
        }
        if (!users[caseLoad.user.id].caseRoles[caseLoad.caseRole.id]) {
          users[caseLoad.user.id].caseRoles[caseLoad.caseRole.id] = {
            caseRole: caseLoad.caseRole,
            patients: []
          };
        }
        users[caseLoad.user.id].caseRoles[caseLoad.caseRole.id].patients.push({
          patient: caseLoad.episodeOfCare,
          caseLoad: caseLoad
        });
      }
      return Object.values(users)
        .sort((u1, u2) =>
          this.formatUser(u1.user)
            .toLowerCase()
            .localeCompare(this.formatUser(u2.user).toLowerCase())
        )
        .map(user => ({
          ...user,
          caseRoles: Object.values(user.caseRoles)
            .sort((cR1, cR2) =>
              cR1.caseRole.name
                .toLowerCase()
                .localeCompare(cR2.caseRole.name.toLowerCase())
            )
            .map(caseRole => ({
              ...caseRole,
              patients: caseRole.patients.sort((eocA, eocB) =>
                this.formatEocObj(eocA)
                  .toLowerCase()
                  .localeCompare(this.formatEocObj(eocB).toLowerCase())
              )
            }))
        }));
    },
    hasFilters() {
      return (
        this.filter.userIds.length > 0 ||
        this.filter.patientsIds.length > 0 ||
        this.filter.caseRoleIds.length > 0
      );
    },
    providerUsers() {
      return this.users.filter(u => u.data.providerInfo);
    }
  },
  watch: {
    showing: {
      handler: function(newValue) {
        if (newValue) {
          this.fetchInitialData();
        }
      },
      immediate: true
    },
    selectedFilter: function() {
      this.$refs.filterDropdown.updatePopper();
    }
  }
};
</script>

<style scoped>
.container-main {
  height: 45px;
}
.case-loads-container {
  box-shadow: inset 0px 16px 10px -16px rgb(0 0 0 / 75%);
}
.filter-select {
  height: 50px;
  width: 300px;
  padding-top: 5px;
}
.search-input {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.caseLoad-card {
  min-width: 180px;
  max-width: 180px;
}
.little-circle {
  width: 10px;
  height: 10px;
}
.little-circle-exclamation {
  width: 20px;
  height: 20px;
}
.little-circle-exclamation-container {
  width: 20px;
  height: 20px;
}
.caseLoad-avatar {
  width: 115px;
  height: 115px;
}
.caseLoad-patient-avatar {
  width: 32px;
  height: 32px;
}
.caseLoad-patient:hover {
  background-color: #e9e9e9;
  border: 1px solid #4044e6;
}
.caseLoad-patient {
  position: relative;
  border: 1px solid #e9e9e9;
  width: 110px;
  height: 73px;
}
.caseRole:before {
  content: "";
  position: absolute;
  border-top: 4px solid #d8d8d8;
  top: 84px;
  left: -24px;
  width: 24px;
}
.caseLoad-data {
  font-size: 10px;
  word-break: break-word;
}
.caseLoads-list {
  height: calc(100vh - 262px - var(--filter-height));
}
.border-yellow {
  border-color: #ffc107 !important;
}
.bg-yellow {
  background-color: #ffc107 !important;
}
.caseLoad-text-data {
  height: 180px;
}
.caseLoad-eoc-data {
  height: 119px;
}
.delete-case-load {
  display: none;
  position: absolute;
  top: 0;
  right: 5px;
}
.caseLoad-patient:hover .delete-case-load {
  display: block;
  font-size: 1rem;
}
.delete-case-load:hover {
  cursor: pointer;
}
.add-case-load-sc {
  font-size: 1rem;
  position: absolute;
  top: 0;
  right: 25px;
  height: 17px;
  text-align: center;
  margin-top: 3px;
  line-height: 1;
  padding-left: 3px;
  padding-right: 3px;
  display: none;
}
.add-case-load-sc:hover {
  cursor: pointer;
}
.caseRole-header {
  background-color: var(--bg-header-color);
  color: var(--font-header-color);
}
.caseRole-header:hover .add-case-load-sc {
  display: initial;
}

.filter-values {
  width: 250px;
}
.filter-patient-values {
  width: 350px;
}
.filter-value {
  min-width: 100px;
  height: 29px;
  color: #a6a6a6;
  font-size: 14px;
  padding-left: 10px;
}
.filter-value-delete {
  position: absolute;
  top: -8px;
  right: -8px;
}
.filter-value-delete:hover {
  cursor: pointer;
}
.clear-all-filters:hover {
  cursor: pointer;
}
.filter-values {
  max-height: 200px;
  overflow-y: auto;
  overflow-x: hidden;
}
.filters-container {
  overflow-x: auto;
}
.min-width-fit-content {
  min-width: fit-content;
}
.admission-data {
  font-size: 13px;
}
.filters-container >>> .container-filter-main-menu {
  min-width: 250px;
  left: -17px;
}
.vertical-separator {
  width: 1px;
  border-left: 1px solid;
  height: 100%;
}
.color-filter {
  color: #909db8;
}
</style>

<style>
.filter-select .vs__dropdown-toggle {
  height: 100%;
  border-radius: 0;
  border: 0;
}
.filter-container .vs__dropdown-toggle {
  height: 50px !important;
  background-color: white;
  border-radius: 0px;
}
</style>
